import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { all_routes } from "../../../Router/all_routes";

/**
 * j'essaie ici de simululé un composant que va agir comme un session dans nos projet php
 * Composant de garde de session : vérifie la présence d'une variable
 * dans localStorage et redirige si elle est absente ou invalide.
 * 
 *
 * @param {string} storageKey - La clé dans le localStorage : avec ceci il sera possible de gere plusieurs variable de session avec le meme composant
 * @param {string} propsup - un element a checker dans le json
 * @param {string} redirectTo - le composant ou il faut rediriger en cas d'absence
 */

const SessionCheck = ({ storageKey = "user", redirectTo = all_routes.menus }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const raw = localStorage.getItem(storageKey);
    if (raw) {//s'il y'a user dans le local storage on rediriger vers la page de menu
      navigate(redirectTo);
      return;
    }
    return;
  }, [navigate, storageKey, redirectTo]);

  return null; // Ce composant ne rend rien
};

SessionCheck.propTypes = {
  storageKey: PropTypes.string,
  propsup: PropTypes.string,
  redirectTo: PropTypes.string,
};

export default SessionCheck;